"use client";
import React from "react";
import { Dialog, DialogContent, IconButton, Box } from "@mui/material";
import { Close } from "@mui/icons-material";
import DonationForm from "./DonationForm";
import DonationSuccess from "./DonationSuccess";

export default function DonationModal({
  open,
  onClose,
  showSuccess = false,
  onExited,
  onSuccess,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      TransitionProps={{
        onExited: onExited,
      }}
      PaperProps={{
        sx: {
          borderRadius: "24px",
          overflow: "hidden",
          backgroundColor: "background.paper",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
          border: "1px solid",
          borderColor: "divider",
          m: { xs: 2, sm: 4 },
          maxHeight: { xs: "calc(100% - 32px)", sm: "calc(100% - 64px)" },
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(28, 36, 29, 0.75)",
            backdropFilter: "blur(4px)",
          },
        },
      }}
    >
      <DialogContent
        sx={{ p: 0, position: "relative", pt: showSuccess ? 0 : 2 }}
      >
        {/* Close Button - only show when not in success state */}
        {!showSuccess && (
          <IconButton
            onClick={onClose}
            aria-label="Close donation modal"
            size="small"
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              backgroundColor: "background.section",
              color: "text.secondary",
              zIndex: 1,
              "&:hover": {
                backgroundColor: "background.hover",
                color: "text.primary",
              },
            }}
          >
            <Close fontSize="small" />
          </IconButton>
        )}

        {showSuccess ? (
          <DonationSuccess onClose={onClose} />
        ) : (
          <DonationForm onSuccess={onSuccess} />
        )}
      </DialogContent>
    </Dialog>
  );
}
